/**
 * Commander Design System - Spacing Scale
 *
 * 8px base unit spacing scale for consistent layouts.
 */

export const spacing = {
  /** 0px */
  0: '0',
  /** 4px - Tight spacing for inline elements */
  1: '0.25rem',
  /** 8px - Default small gap */
  2: '0.5rem',
  /** 12px */
  3: '0.75rem',
  /** 16px - Standard component padding */
  4: '1rem',
  /** 20px */
  5: '1.25rem',
  /** 24px - Card padding */
  6: '1.5rem',
  /** 32px - Section spacing */
  8: '2rem',
  /** 40px */
  10: '2.5rem',
  /** 48px - Large section spacing */
  12: '3rem',
  /** 64px - Page margins */
  16: '4rem',
  /** 80px */
  20: '5rem',
  /** 96px */
  24: '6rem',
} as const;

export const touchTargets = {
  /** 44px - WCAG 2.5.5 minimum touch target */
  minimum: '2.75rem',
  /** 48px - Comfortable touch target */
  comfortable: '3rem',
  /** 64px - Kiosk primary action buttons */
  kioskPrimary: '4rem',
} as const;

export type SpacingKey = keyof typeof spacing;
export type TouchTargetKey = keyof typeof touchTargets;
